"use client"

import React from "react"

import { cn } from "@/lib/utils"
import { forwardRef } from "react"

interface GlowCardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "featured" | "subtle"
  glow?: boolean
  hover?: boolean
}

export const GlowCard = forwardRef<HTMLDivElement, GlowCardProps>(
  ({ className, variant = "default", glow = false, hover = true, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "relative rounded-xl border bg-card p-6 transition-all duration-300",
          variant === "default" && "border-border",
          variant === "featured" && "border-primary/50 gradient-purple-subtle",
          variant === "subtle" && "border-border/50 bg-secondary/50",
          glow && "glow-purple",
          hover && "hover:border-primary/30 hover:bg-secondary/30",
          className
        )}
        {...props}
      >
        {variant === "featured" && (
          <div className="absolute inset-0 rounded-xl bg-radial-purple opacity-50 pointer-events-none" />
        )}
        <div className="relative z-10">{children}</div>
      </div>
    )
  }
)

GlowCard.displayName = "GlowCard"
